exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-content[data-v-b2acea6a] {\n  margin-bottom: 0.020833rem;\n  font-size: 0.078125rem;\n  line-height: 0.104167rem;\n  color: rgba(94, 94, 94, 0.8);\n}\n.content-wrapper[data-v-b2acea6a] {\n  background-color: #fff;\n  border-radius: 0.026042rem;\n  color: #333333;\n}\n.highLight[data-v-b2acea6a] {\n  color: #1e49e2;\n}", ""]);

// exports
